"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The base prefixes default to SHACLC syntax
 */
// TODO: Double check the defaults
exports.default = {
    owl: 'http://www.w3.org/2002/07/owl#',
    rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
    rdfs: 'http://www.w3.org/2000/01/rdf-schema#',
    sh: 'http://www.w3.org/ns/shacl#',
    xsd: 'http://www.w3.org/2001/XMLSchema#',
};
